import React from "react";

const specifications = [
  "Rain water harvesting",
  "Earthquake resistant structure",
  "Well ventilated rooms",
  "Fire safety system",
  "Passenger lifts",
  "Tele security system with intercom facility",
  "100% power back up for lifts, parking & common area",
  "TV & Telephone points in all rooms",
  "Efficient water management",
  "Electrical modular switches & fittings of reputed brands"
];

const reasonsToBuy = [
  "Gated Community",
  "Green Spaces",
  "Top Amenities",
  "Strategic Location",
  "Immediate Possession",
  "JDA Approved",
  "Prime Location in Ajmer Road",
  "Easy Accessibility",
  "Attractive appreciation & high rental yields",
  "Ample parking space"
];

const InfoCard = ({ title, items }) => {
  if (!items || items.length === 0) return null; // Hide if no data
  return (
    <div className="bg-white rounded-lg w-full border border-gray-200">
      {/* Fixed Title */}
      <div className="p-5 border-b border-gray-300 bg-white sticky top-0 z-10">
        <h3 className="text-lg font-semibold">{title}</h3>
      </div>
      
      {/* Scrollable List */}
      <div className="max-h-[300px] overflow-y-auto p-5 ">
        <ul className=" bg-white list-disc list-inside space-y-1 ">
          {items.map((item, index) => (
            <li key={index} className="bg-white">{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const SpecificationsSection = ({project}) => {
  return (
    <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
      <InfoCard title="Specifications" items={project?.specifications} />
      <InfoCard title={`Why Buy in ${project?.basicDetails?.projectName || "Project"} ?`} items={project?.whyBuy} />
    </div>
  );
};

export default SpecificationsSection;
